const blockHtml = `<input class="checkbox-input" name="newsletter-agreement" type="checkbox" required="">
    <span class="indicator" data-tnr-newsletter-agreement="">
    </span>
    <span class="text-privacy">
      Soy mayor de edad, he leído y acepto la
      <span id="external-link-privacy" data-url="/es/landing/_/R-a-politica-privacidad-y-cookies" data-type="extarnel-link" class="cta-link">Política de privacidad</span>
      y la
      <span id="external-link-terms-and-condition" data-url="/es/landing/cg-mydecathlon/_/R-a-cg-mydecathlon" data-type="extarnel-link" class="cta-link"> Condiciones generales Mydecathlon</span>.*
    </span>
    <div class="form-help">
      <div class="caret"></div>
      <div class="text"></div>
    </div>`;

const openExternalLink = (elementId) => {
  const element = document.getElementById(elementId);
  if (element != null) {
    element.addEventListener('click', (e) => {
      if (e.target.hasAttribute('data-url')) {
        window.open(e.target.getAttribute('data-url'), '_blank');
      }
    }, false);
  }
};

const createPoliticAndConditionTermLabelBlock = () => {
  const labelElem = document.createElement('label');
  labelElem.classList.add('label-privacy');
  labelElem.innerHTML = blockHtml;

  return labelElem;
};

const replaceTextPrivacy = () => {

  const indicator = document.querySelector('.indicator[data-tnr-newsletter-agreement]');
  const parentElement = indicator.parentElement.parentElement;

  if (parentElement.firstElementChild.tagName !== 'LABEL') {
    // eslint-disable-next-line no-throw-literal
    throw 'non Existent Element Html';
  }

  const newPoliticAndConditionTermLabel = createPoliticAndConditionTermLabelBlock();

  parentElement.replaceChild(newPoliticAndConditionTermLabel, parentElement.firstElementChild);

  openExternalLink('external-link-privacy');
  openExternalLink('external-link-terms-and-condition');
};

export const refactorTextPrivacyAccepted = () => {

  try {
    replaceTextPrivacy();
  } catch (error) {
    // continue regardless of error
  }
};



// WEBPACK FOOTER //
// ./src/_override/shared/complete-account/refactorPrivacyText.js